import { render } from "./HelpAhsVdhPatientProfile.vue?vue&type=template&id=372f08ee&scoped=true"
import script from "./HelpAhsVdhPatientProfile.vue?vue&type=script&lang=js"
export * from "./HelpAhsVdhPatientProfile.vue?vue&type=script&lang=js"

import "./HelpAhsVdhPatientProfile.vue?vue&type=style&index=0&id=372f08ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372f08ee"]])

export default __exports__